import { useQuery } from '@tanstack/react-query'
import { getToken } from '../internal/tokenCallback'
import { meAdmin } from '../queries/admin.queries'

export const useAdminMe = (options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: ['admin-me'],
    enabled: options?.enabled ?? true,
    queryFn: async () => {
      const token = await getToken()
      if (!token) {
        return null // Pas de token (null ou '') → pas de requête, donc pas de 401
      }
      try {
        const response = await meAdmin()
        return response.user
      } catch {
        return null
      }
    },
  })
